// eslint-disable-next-line import/no-unassigned-import
import './backwards-compat-classname'
import { autoHydrate } from './ssr'
autoHydrate()

export { configureSafeHref, setClassNamePrefix } from 'ui-box'
export { Alert, InlineAlert } from './alert'
export { Autocomplete, AutocompleteItem } from './autocomplete'
export { Avatar } from './avatar'
export { Badge, Pill } from './badges'
export { BackButton, Button, IconButton, TextDropdownButton } from './buttons'
export { Checkbox } from './checkbox'
export { Combobox } from './combobox'
export { StackingOrder, Intent, Position } from './constants'
export { CornerDialog } from './corner-dialog'
export { Dialog } from './dialog'
export { FilePicker } from './file-picker'
export {
  FormField,
  FormFieldDescription,
  FormFieldHint,
  FormFieldLabel,
  FormFieldValidationMessage
} from './form-field'
export { Icon } from './icon'
export { Image } from './image'
export { Pane, Card } from './layers'
export { Menu } from './menu'
export { Overlay } from './overlay'
export { Popover } from './popover'
export { Portal } from './portal'
export { Positioner } from './positioner'
export { Radio, RadioGroup } from './radio'
export { minorScale, majorScale } from './scales'
export { SearchInput } from './search-input'
export { SegmentedControl } from './segmented-control'
export { Select, SelectField } from './select'
export {
  OptionShapePropType,
  OptionsList,
  SelectedPropType,
  SelectMenu,
  SelectMenuContent
} from './select-menu'
export { SideSheet } from './side-sheet'
export { Spinner } from './spinner'
export { Switch } from './switch'
export { extractStyles } from './ssr'
export { Stack, StackingContext } from './stack'
export {
  Table,
  TableHead,
  TableHeaderCell,
  TextTableHeaderCell,
  SearchTableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
  TextTableCell
} from './table'
export { SidebarTab, Tab, Tablist, TabNavigation } from './tabs'
export { TagInput } from './tag-input'
export { TextInput, TextInputField } from './text-input'
export {
  ThemeContext,
  ThemeProvider,
  ThemeConsumer,
  withTheme,
  useTheme,
  defaultTheme
} from './theme'
export { Textarea, TextareaField } from './textarea'
export { toaster } from './toaster'
export { Tooltip } from './tooltip'
export {
  UnorderedList,
  Ul,
  OrderedList,
  Ol,
  ListItem,
  Li,
  Text,
  Paragraph,
  Heading,
  Code,
  Pre,
  Label,
  Link,
  Small,
  Strong
} from './typography'

/* Start generated icons */
export * from './icons'
/* End generated icons */
